<template>
  <div class="d-block d-lg-flex fondo-principal texto-principal">
      <SideNavBar />
  </div>
</template>

<script>
import SideNavBar from "./components/SideNavBar.vue";

export default {
  components: {
    SideNavBar,
  },
  setup() {
    return {
    };
  },
};
</script>

<style>
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}

.form-signin .checkbox {
  font-weight: 400;
}

.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}

.form-signin .form-control:focus {
  z-index: 2;
}

.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}


.btn-blanco {
  background-color: white;
  color: black;
}
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-container .tooltip-text {
  visibility: hidden;
  background-color: var(--fondo-secundario);
  border: 1px solid var(--fondo-secundario);
  color: var(--texto-principal);
  text-align: left;
  border-radius: 10px;
  padding: 5px 8px;
  position: absolute;
  z-index: 5;
  bottom: 100%; /* Aparece sobre el botón */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-text-left{
  visibility: hidden;
  background-color: var(--fondo-secundario);
  border: 1px solid var(--fondo-secundario);
  color: var(--texto-principal);
  text-align: left;
  border-radius: 6px;
  padding: 5px 8px;
  position: absolute;
  z-index: 1;
  bottom: 100%; /* Aparece sobre el botón */
  left: 100%;
  transform: translateX(-100%);
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-text-right{
  visibility: hidden;
  background-color: var(--fondo-secundario);
  border: 1px solid var(--fondo-secundario);
  color: var(--texto-principal);
  text-align: left;
  border-radius: 6px;
  padding: 5px 8px;
  position: absolute;
  z-index: 1;
  bottom: 100%; /* Aparece sobre el botón */
  right: 100%;
  transform: translateX(100%);
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-container:hover .tooltip-text{
  visibility: visible;
  opacity: 1;
}
.tooltip-container:hover .tooltip-text-left{
  visibility: visible;
  opacity: 1;
}
.tooltip-container:hover .tooltip-text-right{
  visibility: visible;
  opacity: 1;
}
.side-nav-bar {
  position: static;
  top: 0;
  left: 0;
}
.btn-add {
  background-color: #006330;
  color: #ffffff;
}
.disabled-input {
  background-color: #e9ecef;
  opacity: 1;
  user-select: none; /* Evita la selección de texto */
  cursor: default; /* Mantiene el cursor normal */
}
.text-truncate-1 {
  line-clamp: 1;
  -webkit-line-clamp: 1;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.text-truncate-2 {
  line-clamp: 2;
  -webkit-line-clamp: 2;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.text-truncate-3 {
  line-clamp: 3;
  -webkit-line-clamp: 3;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.hover-row {
  position: relative;
  display: inline-block; /* Asegura que cada p sea tratado como bloque independiente */
}
.hover-row:hover::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.05); /* Oscurecer el fondo */
  pointer-events: none;
  transition: background-color 0.2s ease-in-out;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000; /* Debe estar por debajo del menú */
}

/* Para pantallas grandes (más de 992px), el sidebar se vuelve estático */
@media (min-width: 992px) {
  .side-nav-bar {
    position: fixed;
    top: 0;
    left: 0;
  }
}
</style>
